var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SmartLink',{staticClass:"header-logo",attrs:{"route":_vm.route}},[_c('UkaskoLogo',{staticClass:"header-logo-icon",attrs:{"width":150,"height":27}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }